import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './styles/product-search.scss.js';
import { renderInteractiveElement } from '../../atoms/generic-elements/interactive-element/index.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';

/* eslint-disable class-methods-use-this */
class PimSearch extends s {
    constructor() {
        super(...arguments);
        this.render = () => {
            const btnProps = {
                mainClass: 'primary-button',
                style: ButtonStyleTypes.DARK,
                isAnchor: false,
                text: 'Search',
                disabled: false,
                mobileInverted: false,
                mobileWhite: false,
                rtl: false,
            };
            return x `<div class="product-search-container"><input class="product-search-bar" type="text" autocomplete="off"><generic-button class="product-search-button" type="primary-button" styleType="${ButtonStyleTypes.DARK}" size="fullWidth">${renderInteractiveElement(btnProps)}</generic-button></div>`;
        };
    }
}
PimSearch.styles = css_248z;
customElements.define('product-search', PimSearch);

export { PimSearch };
